'use strict';
import React from 'react';
import Spinner from 'spin.js';

var LoadingSpinner = React.createClass({
    displayName: 'LoadingSpinner',
    getDefaultProps() {
        return {
            config: {
                lines: 15,
                radius: 31,
                width: 4,
                length: 0,
                trail: 63,
                color: '#aaaaaa'
            }
        };
    },
    componentDidMount: function() {
        this.spinner = new Spinner(this.props.config);
        this.spinner.spin(this.refs.container.getDOMNode());
    },
    componentWillReceiveProps: function(newProps) {
        if (newProps.stopped === true && !this.props.stopped) {
            this.spinner.stop();
        } else if (!newProps.stopped && this.props.stopped === true) {
            this.spinner.spin(this.refs.container.getDOMNode());
        }
    },
    componentWillUnmount: function() {
        this.spinner.stop();
    },
    render() {
        return (<div className="spinner"><span ref="container" /></div>);
    }
});

module.exports = LoadingSpinner;



// WEBPACK FOOTER //
// ./app/components/spinner/spinner.jsx